module.exports = __webpack_public_path__ + "img/il-gallery-unauthorised.c7a4d11.svg";